import React from 'react';
import { useIntl } from 'react-intl';
import { ResourceBookingHeader } from 'components/headers/resourceBookingHeader';
import { useBackButtonVisibility } from 'hooks/use-back-button-visibility.hook';
import { useHeader } from './hooks/use-header.hook';
import { useLocation } from 'react-router-dom';
import { LANDING_PATH } from 'shared/consts';

/**
 * Sub-routes this page opens as modals over itself rather than pages of their own — the filters
 * sheet (`useFilterModalNavigation`) and the terms modals in `ResourcesPage`'s own `Routes`.
 *
 * The arrow has to read the page underneath the modal. With `resourceBookingSkipLandingPage` on this
 * page *is* the landing path, so opening the filters would otherwise turn `/` into `/filter-by` and
 * conjure a "Back" to somewhere the user has never been — and pressing it resets the resource list
 * on the way out.
 */
const MODAL_SUB_ROUTE = /\/?(quick-checkout\/)?(filter-by|terms-and-conditions)$/;

export const Header = (): JSX.Element => {
  const intl = useIntl();
  const isBackButtonVisible = useBackButtonVisibility();
  const { isHeaderVisible, onPressBack, onMyBookingsClick } = useHeader();
  const { pathname } = useLocation();
  const pagePathname = pathname.replace(MODAL_SUB_ROUTE, '') || LANDING_PATH;
  const withBackButton = isBackButtonVisible && pagePathname !== LANDING_PATH;

  if (!isHeaderVisible) return null;

  return (
    <ResourceBookingHeader
      title={intl.formatMessage({ id: 'reserveSpace' })}
      withBackButton={withBackButton}
      onBackClick={onPressBack}
      onMyBookingsClick={onMyBookingsClick}
    />
  );
};
